var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgHandbaginline = function SvgHandbaginline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M499 410l-36-214c-4-23-26-40-51-40h-57V94c0-52-47-94-105-94S146 42 146 94v62H88c-25 0-47 17-51 40L1 410c-7 43 26 83 73 89l13 1h326c48 0 87-35 87-78l-1-12zM180 94c0-35 32-63 70-63s70 28 70 63v62H180V94zm241 374l-8 1H87c-29 0-52-21-52-47v-7l36-214c2-8 9-13 17-13h58v11.1c-3.2-.7-6.6-1.1-10-1.1-25 0-44 19-44 43 0 23 19 42 44 42 24 0 44-19 44-42 0-1.5-.1-2.9-.2-4.4.1-.9.2-1.7.2-2.6v-46h140v46c0 .9.1 1.8.2 2.6-.1 1.4-.2 2.9-.2 4.4 0 23 20 42 44 42s44-19 44-42c0-24-20-43-44-43-3.1 0-6.1.3-9 .9V188h57c8 0 16 5 17 13l36 214c4 26-16 49-44 53z"
  })));
};

export default SvgHandbaginline;